import LoginBar from './loginBar'

const $document = $(document)

if ($document.find('.js__loginBar').length && !window.application.user) {
  $document.on('click', '.js__loginBar', (e) => {
    $document.trigger('showLoginBar')
    e.preventDefault()
  })

  const $loginBar = $('<div>').appendTo('body')
  $loginBar.reactify(LoginBar)
  $loginBar.children().unwrap()
}
